import React from 'react';
import './Callout.scss';

interface CalloutProps {
  variant: 'info' | 'warning' | 'success' | 'error';
  icon?: string;
  title: string;
  subtitle?: string;
  className?: string;
}

const Callout = ({
  variant,
  icon,
  title,
  subtitle,
  className = '',
}: CalloutProps) => {
  return (
    <div className={`callout callout-${variant} ${className}`}>
      <div className="callout-content">
        {icon && <span className="callout-icon">{icon}</span>}
        <div className="callout-text">
          <p className="callout-title">{title}</p>
          {subtitle && <p className="callout-subtitle">{subtitle}</p>}
        </div>
      </div>
    </div>
  );
};

export default Callout;
